import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MibpToastComponent } from './toast.component';
import { ToastService } from 'root/shared/services/toast-service/toast.service';

@Component({
  selector: 'mibp-toast-host',
  template: `
    <div class="mibp-toast-container">
      @for (toast of toastService.toasts(); track toast.id) {
        <mibp-toast
          [toast]="toast"
          (dismiss)="toastService.removeToast($event)"
          (action)="toastService.triggerAction($event.toastId, $event.button)"
          (shown)="toastService.markShown($event)"
          (mouseenter)="toastService.pauseTimeout(toast.id)"
          (mouseleave)="toastService.resumeTimeout(toast.id)"
        ></mibp-toast>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MibpToastComponent]
})
export class MibpToastHostComponent {
  protected readonly toastService = inject(ToastService);
}